// Single source of truth for the marketing site's primary navigation.
// Read by both `Header.tsx` (runtime rendering) and `seo.ts`
// (`SiteNavigationElement` JSON-LD generator). Drift between consumers
// is pinned by `src/test/seo.test.tsx::nav source-of-truth drift guard`.
// The canonical, locale-independent route ids. A German URL is this id under a
// `/de` prefix, never a translated slug, which is what keeps one route table
// serving both locales and the hreflang pairs derivable rather than authored.
export const NAV_ROUTE_IDS = [
  "/",
  "/how-it-works",
  "/platforms",
  "/tradable-assets",
  "/support",
] as const;

export type NavRouteId = (typeof NAV_ROUTE_IDS)[number];

// This module owns WHERE the nav points, never WHAT it says. Labels live in
// `src/content/<locale>/chrome.ts` keyed by these same ids, so there is exactly
// one source per locale and no spelling of a destination can drift between the
// header, the footer and the SiteNavigationElement JSON-LD.
export interface NavItem {
  id: NavRouteId;
  end: boolean;
}

export const NAV_ITEMS: ReadonlyArray<NavItem> = [
  { id: "/", end: true },
  { id: "/how-it-works", end: false },
  { id: "/platforms", end: false },
  { id: "/tradable-assets", end: false },
  { id: "/support", end: false },
] as const;
